import { Company } from '../types/company';

export const findCompany = (
  companies?: Company[],
  companyId?: string
): Company | undefined =>
  companies?.find((company) => company.id === companyId);
